import BaseModelAPI from '../BaseModelAPI';

export default class DeliveryInstructionList extends BaseModelAPI {

	static entity = 'deliveryinstructionlist'
	static entityName = 'deliveryinstruction';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
